import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Header.css';

const Header = ({ buttons = [], onNavClick, activeButton: initialActiveButton = 1 }) => {
  const [currentActiveButton, setCurrentActiveButton] = useState(initialActiveButton);
  const navigate = useNavigate();
  
  const navButtons = buttons;

  const handleNavClick = async (button) => {
    setCurrentActiveButton(button.id);
    
    // Pass click to parent first (e.g. refreshCache before Start Learning)
    if (onNavClick) {
      const result = onNavClick(button);
      if (result && typeof result.then === 'function') {
        await result;
      }
    }
    
    // Handle navigation if path is provided (after parent logic completes)
    if (button.path) {
      navigate(button.path);
    }
        
    console.log(`Clicked: ${button.label}`);
  };

  return (
    <nav className="navigation-bar">
      <div className="nav-logo">
        <Link to="/" aria-label="Go to homepage">
          <img src={process.env.PUBLIC_URL + '/ITZ.Logo.png'} alt="ITZ Logo" className="logo-image" />
        </Link>
        <div className="logo-content">
        </div>
      </div>
      
      <div className="nav-buttons">
        {navButtons.map(button => (
          <button
            key={button.id}
            className={`nav-button ${currentActiveButton === button.id ? 'active' : ''} ${button.label === 'Dashboard' || button.label === 'Start Learning' ? 'long-text' : ''} ${button.label === 'Settings' || button.label === 'Logout' ? 'small-button' : ''}`}
            onClick={() => handleNavClick(button)}
          >
            <span className="button-label">{button.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default Header;